export const formatVehicle = (
  brandName: string,
  modelName: string,
  versionName: string,
  hp: number,
  modelYear: number,
) => {
  return `${brandName} ${modelName} ${versionName} ${hp} CV ANO ${modelYear}`;
};
